export default {
    首页: {
        首页: "Home",
        产品: "Products",
        场景: "Scenarios",
        可持续发展: "Sustainability",
        联系我们: "Contact Us",

        "引领智能餐饮新生态": "LEADING A NEW ECOSYSTEM OF INTELLIGENT CATERING",
        "为校园、企业、医院、商超等场景": "Designed for campuses, enterprises, hospitals, supermarkets, and more",
        "提供2-4分钟现蒸热食24/7可运营的自动热食供应方案":"A fully automated hot-meal solution delivering freshly steamed meals in 2-4 minutes,24/7",
        "观看视频演示": "Watch Video Demo",

        "智能餐饮新生态": "A New Ecosystem of Intelligent Catering",
        "智能餐饮设备": "Intelligent Catering Equipment",
        "24小时在线的智慧无人厨房，触手可及的餐饮新体验":"A 24/7 intelligent unmanned kitchen, redefining modern food service accessibility",

        "食材供应链": "Ingredient Supply Chain",
        "从源头锁鲜的直供网络，安心可溯的品质基石":"A direct-from-source supply network that preserves freshness and ensures full traceability",

        "高效运营": "Efficient Operations",
        "云端协同的智能运维系统，保障全局的高效运转":"A cloud-connected intelligent operations system ensuring reliable and efficient performance",

        "数字化平台": "Digital Platform",
        "洞察需求的AI数据大脑，驱动生态的智慧核心":"An AI-powered data engine that understands demand and drives continuous optimization",

        "我们的发展历程": "Development Journey",
        "启航奠基": "Foundation",
        "公司于杭州成立": "Founded in Hangzhou",
        "确立以全自动智能化商用鲜食机为核心的发展方向":"Defined a development strategy centered on fully automated intelligent fresh-food machines.”",

        "提出\"科技传承美食，数据驱动变革\"的企业使命":"Introduced the corporate mission:\"Preserving food culture through technology, driving transformation through data.\"",

        "深耕攻坚": "Deep Cultivation",
        "集中研发力量，攻坚底层核心技术":"Focused R&D efforts on core underlying technologies",
        "突破蒸煮温控算法、食材保鲜系统等关键难题":"Achieved breakthroughs in cooking temperature control algorithms and ingredient preservation systems",
        "为产品智能化与量产化奠定坚实基础":"Laid a solid foundation for product intelligence and mass production",

        "突破绽放": "Expansion",
        "V31蒸煮一体机成功量产，并进军德国慕尼黑市场":"The V31 all-in-one steamer-cooker was successfully mass-produced and launched in the Munich, Germany market",
        "V21煮面机完成迭代":"The V21 noodle cooker completed its next-generation upgrade",
        "V41桌面蒸煮一体机开发完成":"Development of the V41 desktop all-in-one cooking unit was completed",

        "未来": "Future",
        "拓展引领": "Leadership",
        "产品开发:以AI为决策核心，以大数据为优化引擎，驱动产品矩阵迭代升级":"Product Development: Leveraging AI as the decision-making core and big data as the optimization engine to continuously evolve the product portfolio",
        "市场开拓:以德国市场为基点，迈向全球，携手合作伙伴共建智能餐饮新生态":"Market Development: Starting from Germany and expanding globally, partnering to build the next generation of intelligent catering ecosystems",

        "视频加载中，请稍候...":"Video loading, please wait…",
        "视频加载失败，请刷新重试":"Video load failed. Refresh and try again.",

        "产品矩阵": "Product Portfolio",
        "智能餐食站": "Intelligent Meal Station",
        "您的24小时现代化餐饮解决方案伙伴":"Your modern, automated food service partner, available 24/7",

        "空间高效，灵活布局": "Space-efficient design with flexible deployment",
        "运维经济，全天候服务": "Cost-efficient operations with round-the-clock service",
        "模块组合，按需定制": "Modular configuration tailored to your needs",
        "提升体验，增值空间": "Enhanced user experience and additional revenue opportunities",

        "鲜食售货机": "Fresh Food Vending Machine",
        "煮面机": "Boiling Machine",
        "冰淇淋机": "Ice Cream Machine",
        "零食饮料机": "Snack and Beverage Machine",
        "饮品机": "Beverage Machine",

        "多样化菜单": "Diversified Menu",
        "菜单定期更新、支持定制，覆盖多地区口味与饮食文化":"Menus are regularly updated and customizable, covering diverse regional tastes and food cultures",

        "盖饭": "Rice Bowls",
        "炒饭": "Fried Rice",
        "拌面": "Mixed Noodles",
        "汤面": " Soup Noodle",
        "饺子": "Dumplings",
        "虾饺": "Shrimp Dumplings",
        "包子": "Steamed Buns",
        "烧麦": "Shumai",
        "意面": "Pasta",
        "关东煮": "Oden",
        "咖喱饭": "Curry Rice",
        "冬阴功汤": "Tom Yum Soup",
        "芝士蛋糕": "Cheesecake",
        "慕斯蛋糕": "Mousse Cake",
        "甜羹": "Sweet Soup",
        "甜包": "Sweet Buns",

        "产品优势": "Product Advantages",
        "随取随热减少浪费": "Heat-on-Demand to Minimize Food Waste",
        "按需制作，避免食物浪费，节省成本。":"Meals are prepared on demand, reducing food waste and operational costs",

        "无需厨房，降低运营成本": "No Kitchen Required, Lower Operating Costs",
        "3平米即可部署，无需厨师与复杂厨房设施。":"Deployable within 2 ㎡, without chefs or traditional kitchen infrastructure",

        "24-7全天候服务": "24/7 Availability",
        "填补夜间、假日等非高峰时段餐饮空白。":"Fills food service gaps during nights, holidays, and other off-peak periods",

        "菜单灵活，适配多样人群": "Flexible Menus for Diverse Audiences",
        "支持多地风味，满足不同饮食需求。":"Supports multiple regional flavors and dietary preferences",

        "远程管理，智能运维": "Remote Monitoring and Intelligent Operations",
        "通过手机或电脑实时监控设备状态与销售数据。":"Real-time monitoring of machine status and sales data via mobile or desktop",

        "丰富的应用场景": "Scenarios",
        "合作伙伴": "Partners",

        "智能餐饮 绿色未来": "Intelligent Catering, A Sustainable Future",
        "Homierobot在设计之初即考虑餐饮运营中的可持续需求，通过减少食物浪费、优化资源使用，并支持符合欧盟法规的包装方案，帮助运营方更轻松地实现合规与环保目标。":"Sustainability is embedded into Homierobot’s design from day one. By reducing food waste, optimizing resource efficiency, and supporting EU-compliant packaging solutions, we help operators achieve both regulatory compliance and environmental goals with ease.",

        "减少浪费": "Reduce Waste",
        "按需出餐，精准供应": "On-demand cooking with precise supply",
        "高效节能": "High Energy Efficiency",
        "紧凑设计，智能温控": "Compact design with intelligent temperature control",
        "环保包装": "Eco-friendly Packaging",
        "支持可降解、可循环餐盒": "Supports biodegradable and recyclable food containers",

        "合作咨询": "Business Inquiry",
        "我们欢迎与运营方、经销商及各类合作伙伴展开合作，探索自动热食在不同场景下的试点与落地。":"We welcome collaboration with operators, distributors, and strategic partners to pilot and deploy automated hot-meal solutions across diverse scenarios.",

        "姓": "First Name",
        "名": "Last Name",
        "邮箱": "Email",
        "公司": "Company",
        "职务/部门": "Job Title / Department",
        "手机号": "Phone Number",
        "咨询内容": "Message",
        "提交信息": "Submit",
        "邮箱不能为空": "Email is required",
        "请输入正确的邮箱地址": "Please enter a valid email address",
        "请填写": "Required field",
        "提交成功,请等待我们的联系":
            "Submission successful. Our team will contact you shortly.",


        "WhatsApp":"WhatsApp",
        "Email":"Email",
        "回到顶部": "Back to Top"
    }
}
